import { render, staticRenderFns } from "./extenddef.vue?vue&type=template&id=e3670ff6&scoped=true&"
import script from "./extenddef.vue?vue&type=script&lang=js&"
export * from "./extenddef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3670ff6",
  null
  
)

export default component.exports